module.exports = __webpack_public_path__ + "img/period.4c1de8f6.jpg";